import React from 'react';
import PropTypes from 'prop-types';

function Timeline(props) {
  const { timeLineImageUrls, onTimelineClick } = props;

  return (
    <div className="timeline-container">
      <div
        id="timeline"
        className="timeline"
        onMouseDown={(e) => {
          onTimelineClick(e.clientX);
        }}
      >
        {timeLineImageUrls.map((url, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index}>
            <img alt={index} src={url} />
          </div>
        ))}
      </div>
    </div>
  );
}

Timeline.propTypes = {
  timeLineImageUrls: PropTypes.array.isRequired,
  onTimelineClick: PropTypes.func.isRequired,
};

export default Timeline;
